import { Routes, RouterModule } from '@angular/router';
import { OverrideReportingScreenComponent } from './override-reporting.component';

const overrideReportingRoutes: Routes = [
];

export const OverrideReportingRouter = RouterModule.forChild(overrideReportingRoutes);